import React from "react";
import { Modal } from "antd";
import "./simple.modal.css";
import CustomButton from "../Buttons/CustomButton";
import closeIconImgStatic from "../../../assets/close__s__stroke.svg";

const SimpleModal = ({
  show,
  setShow,
  title,
  body,
  onOkFn,
  onCancelFn,
  modalClsNames = "mas-modal-container",
  titleClsNames = "mas-modal-title",
  bodyClsNames = "mas-modal-body",
  footerClsNames = "d-flex justify-content-end gap-2",
  width = 450,
  cancelText = "Cancel",
  confirmText = "Delete",
  centered = true,
  closeIcon = true,
  closeIconImg,
  maskClosable = true,
  children,
}) => {
  const handleOk = (e) => {
    if (onOkFn) {
      onOkFn(e);
    }
  };

  const handleCancel = (e) => {
    if (onCancelFn) {
      onCancelFn(e);
    } else {
      setShow(false);
    }
  };

  return (
    <Modal
      open={show}
      onCancel={handleCancel}
      onOk={handleOk}
      title={null}
      className={modalClsNames}
      centered={centered}
      closeIcon={
        closeIcon ? (
          <img src={closeIconImg || closeIconImgStatic} alt="Close" />
        ) : null
      }
      footer={null}
      maskClosable={maskClosable}
      width={width}
    >
      {children ? (
        <>{children}</>
      ) : (
        <>
          <div className={titleClsNames}>{title}</div>
          <div className={bodyClsNames}>{body}</div>
          <div className={footerClsNames}>
            <CustomButton
              clsNames="mas-secondary-btn-3 mas-btn-sml"
              onClickFn={(e) => onCancelFn(e)}
              label={cancelText}
            />
            <CustomButton
              clsNames="mas-primary-btn mas-btn-sml"
              onClickFn={(e) => onOkFn(e)}
              label={confirmText}
            />
          </div>
        </>
      )}
    </Modal>
  );
};

export default SimpleModal;
